/**
 * Message the studio's standard look (bookings.html and telify-pages.html's
 * Questions block): the studio's logo when it has one, the heading and line,
 * then Message the studio under them. Draws the behavior half's state and calls
 * its action; holds no rule.
 */
import { partsOf, pieceRoot } from '../../contract/runtime';
import shared from '../../styles/shared.module.css';
import { Icon } from '../../ui/Icon';
import account from '../../styles/account.module.css';
import css from './MessageStudio.module.css';
import { contract } from './contract';
import type { MessageStudioRuntime } from './useMessageStudio';

const part = partsOf(contract);

export function MessageStudioView({ state, actions }: MessageStudioRuntime) {
  if (state.status === 'loading') return null;
  return (
    <section
      className={`${css.block} ${state.logoUrl ? css.withLogo : ''}`}
      aria-label={state.line.replace(/\.$/, '')}
      {...pieceRoot(contract)}
      {...part('section')}
    >
      {state.logoUrl && <img className={css.logo} src={state.logoUrl} alt="" {...part('logo')} />}
      <div>
        <h2 className={css.title} {...part('title')}>
          {state.heading}
        </h2>
        <p className={css.line} {...part('line')}>
          {state.line}
        </p>
      </div>
      <button
        type="button"
        className={`${shared.btn} ${account.btnLine} ${css.button}`}
        disabled={!state.ready || state.signingIn}
        onClick={actions.messageStudio}
        {...part('messageStudio')}
      >
        <Icon name="msg" />
        Message the studio
      </button>
      {state.signInFailed && (
        <p className={css.error} role="alert" {...part('signInError')}>
          Sign in did not go through. Please try again.
        </p>
      )}
    </section>
  );
}
